import * as Sentry from "@sentry/react";

const initSentry = () => {
  if (import.meta.env.VITE_SENTRY_DSN) {
    Sentry.init({
      dsn: import.meta.env.VITE_SENTRY_DSN,
      tunnel: "/error-tunnel",
      environment: process.env.SENTRY_ENVIRONMENT || import.meta.env.VITE_ENV,
      sendDefaultPii: true,
      release: `${process.env.npm_package_version}@${process.env.npm_package_version}`,
      sampleRate: 0.1, // 20%, Error 採樣率，如果預期會有很多錯誤一開始設 0.1 ~ 0.3
      profilesSampleRate: 0.2, // 20%, 效能分析採樣率
      integrations: [
        Sentry.browserProfilingIntegration(), // 啟用效能分析
        Sentry.httpClientIntegration(), // 啟用捕捉 Fetch, XHR 錯誤
      ],
    });
  }
};

export default initSentry;
